import { useCancelRFS } from "@/api/rfs";
import {
  alertConfirmationReject,
  swalError,
  swalSuccess,
} from "@/utils/lib/swal";
import { useNavigate } from "react-router-dom";

function useDocumentCancel({ id }: { id: string }) {
  const navigate = useNavigate();
  const { mutate: submit } = useCancelRFS();

  function handleCancel() {
    alertConfirmationReject(cancelMutation, {
      title: "Alert",
      text: "This action cannot be undone. Are you sure want to cancel this RFS submission?",
      minRemarksLength: 10,
      inputPlaceholder: "Reason",
    });
  }

  function cancelMutation(notes: string) {
    submit(
      {
        id,
        params: {
          decision: "yes",
        },
        data: { cancelReason: notes },
      },
      {
        onSuccess: () => {
          swalSuccess
            .fire({
              title: "Successfully Cancelled",
              text: "You have successfully canceled rfs submission.",
            })
            .then(() => {
              navigate(0);
            });
        },
        onError: () => {
          swalError
            .fire({
              text: "You have unsuccessfully canceled rfs submission.",
            })
            .then(() => {
              navigate(0);
            });
        },
      },
    );
  }

  return {
    handleCancel,
  };
}

export { useDocumentCancel };
